<!-- src/components/Navbar.vue -->
<template>
  <nav class="navbar">
    <div class="navbar-brand"> <b-img fluid width="100" :src="require('@/assets/logo-branca-int.png')" /></div>
    <div class="navbar-items">
      <router-link v-if="user && user.role && user.role.common" to="/dashboard">
       Dashboard
      </router-link>
      <router-link v-if="user && user.role && !user.role.common" to="/register-company">Cadastrar Empresa</router-link>
      <button @click="handleLogout" class="logout-btn">Sair</button>
    </div>
  </nav>
</template>

<script>
export default {
  computed: {
    
    user() {
      return this.$store.getters.user;
    },
  },
  methods: {
    handleLogout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped>
.navbar {
  background: #001f3f;
  color: white;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.navbar a {
  color: white;
  text-decoration: none;
  margin-right: 1rem;
}

.logout-btn {
  background: #4da6ff;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
}
.navbar-items a {
  color: white;
  text-decoration: none;
  margin-right: 1.5rem;
  padding: 0.5rem 0;
  position: relative;
  transition: all 0.3s ease;
}

.navbar-items a:hover {
  color: #4da6ff;
}

.navbar-items a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: #4da6ff;
  transition: width 0.3s ease;
}

.navbar-items a:hover::after {
  width: 100%;
}

.logout-btn:hover {
  background: #3a8bd6;
  transform: translateY(-1px);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}
.router-link-exact-active {
  color: #4da6ff !important;
}
</style>
